import { Box, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { NivosEvent } from 'types/nivos-event'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

interface OwnProps {
  events: NivosEvent[]
  header?: string
}

type AppProps = StateProps & DispatchProps & OwnProps

const NivosEventItem: React.FC<{ event: NivosEvent }> = props => {
  const { event } = props
  return (
    <Box width={1} maxWidth={'75vw'}>
      <Box display={'flex'} alignItems={'center'}>
        <Box padding={2}>
          <Typography variant={'h5'}>{event.date.getDate()}</Typography>
          <Typography variant={'h5'}>
            {event.date.toLocaleString('default', { month: 'short' })}
          </Typography>
        </Box>
        {event.image != null && (
          <Box padding={2} height={96}>
            <img
              style={{ borderRadius: '12px' }}
              height={96}
              width={'auto'}
              src={event.image}
              alt={`nivos-${event.eventName}-image`}
            />
          </Box>
        )}
        <Box padding={2}>
          <Typography>
            <strong>{event.eventName}</strong>
          </Typography>
          <Typography variant={'body2'} maxHeight={75} overflow={'hidden'}>
            {event.description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

const NivosDatesFC: React.FC<any> = (props: AppProps) => {
  const { events, header } = props

  return (
    <Box width={1} minHeight={600}>
      <Box
        width={1}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        {header != null && (
          <Typography variant={'h4'} marginY={1}>
            {header}
          </Typography>
        )}
        <Box
          width={1}
          padding={2}
          margin={2}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
        >
          {events.map((event, index) => (
            <NivosEventItem event={event} key={index} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const NivosEvents = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosDatesFC) as React.FC<OwnProps>

export default NivosEvents

export { NivosEventItem }
